import OptionGroup from '../models/optionGroup';
import namespace from '../../upi/namespace';

var app = namespace( 'apps.productpage' );

var OptionGroupList = Backbone.Collection.extend( {

    model: OptionGroup,

    initialize: function ( models, options ) {
        this.skuList = options.skuList || app.skuList;

        var self = this;
        this.listenTo( this, 'filter:options', this.handleOptionFilter );
        this.listenTo( app.mediator, 'set:options', this.setSelected );
    },

    clearSelectedOptions: function () {
        this.each( function ( optionGroup ) {
            optionGroup.trigger( 'clear:selected' );
        } );
    },

    /**
     * Get a list of selected option from each OptionGroup collection
     * @returns {Object} - key value pairs { optionGroupId: optionId }
     */
    getSelected: function () {
        var selected = {};

        this.each( function ( optionGroup ) {
            var current = optionGroup.optionList.current();
            selected[optionGroup.get( 'id' )] = (current)
                ? current.get( 'id' )
                : null;
        } );

        return selected;
    },

    /**
     * Iterate over optionGroupsIds using skuOptions hash to set selected options within each optionList
     * @param {object} skuOptions - hash containing sku options
     */
    setSelected: function ( skuOptions ) {
        this.each( function ( optionGroup ) {
            var optionId = skuOptions[optionGroup.get( 'id' )],
                option = optionGroup.optionList.find( {id: optionId} );

            optionGroup.optionList.current( option );
        } );
    },

    getOptionsByAvailability: function ( optionGroupId, requiredOpts = {} ) {
        const skus = this.skuList.models;
        // filtering null values for comparing selected options against each skus option list
        let requiredValues = Object.values( requiredOpts ).filter( i => i != null );

        const filtered = skus.filter( sku => {
            let opts = Object.values( sku.get( 'options' ) );
            return _.difference( requiredValues, opts ).length === 0;
        } );

        return filtered.map( sku => sku.get( 'options' )[optionGroupId] );
    },

    /**
     * Inspect current selection in each option list, if option is flagged unavailable then invalidate this selection
     * by clearing and unsetting the current option for this option list
     * Refilter optionGroups if an invalid selection is detected
     */
    invalidateSelections: function () {
        var invalid = false;

        this.each( ( optionGroup ) => {
            var option = optionGroup.optionList.current();

            // available options are being computed based on this selection
            if ( option && !option.get( 'available' ) ) {
                // while not primaryOption OR only one optionGroup
                if ( !option.get( 'primaryOption' ) || option.get( 'primaryOption' ) && this.length <= 1 ) {
                    invalid = true;
                    console.log( 'invalidated option:', option.attributes );
                    option.trigger( 'invalidated' ); //=> bubbles an event to 'filter:options' @ this.handleOptionFilter
                }
            }
        }, this );

        return invalid;
    },

    handleOptionFilter: function () {
        // refactor method, handleOptionFilter, filterAvailableOptionsFor
        var selected = this.getSelected();

        // target filter on opposing optionGroups
        if ( this.length > 1 ) {
            // -> for each optionGroup that has a selection
            for ( var optionGroupId in selected ) { // @key => optionGroupId
                if ( selected.hasOwnProperty( optionGroupId ) ) {
                    this.filterAvailableOptionsFor( optionGroupId, selected );
                }
            }
        }
        else {
            // refactor - dups @filterAvailableOptionsFor
            var optionGroup = this.first(),
                availableOptionsIds = this.getOptionsByAvailability( optionGroup.get( 'id' ) );
            optionGroup.optionList.toggleAvailableOptions( availableOptionsIds );
        }

        // ensure that current option combination is valid,
        // if so trigger mediator event to render sku data
        this.disableUnmatchedOptions();
        this.invalidateSelections();
        this.trigger( 'change:option' );

    },

    filterAvailableOptionsFor: function ( optionGroupId, selectedOptions ) {
        const opts = Object.assign( {}, selectedOptions );
        delete opts[optionGroupId];
        // -> then toggle options on opposing optionLists where sku does not exist for optionId
        var availableOptionsIds = this.getOptionsByAvailability( optionGroupId, opts );
        var optionGroup = this.findWhere( {id: parseInt( optionGroupId )} );
        optionGroup.optionList.toggleAvailableOptions( availableOptionsIds );
    },

    // disable all options that are not matched with any sku within OptionGroupList.skuList
    disableUnmatchedOptions: function () {
        var
            // builds dict of optionId: [allOptionIds]
            availableSkuOptionsHash = this.skuList.getAvailableOptionGroupsHash(),
            unmatched = this.getUnmatchedOptionsHash( availableSkuOptionsHash ); //{ 1: [1,4], 2: [6] };

        // iterates over final dict disabling remaining options
        for ( var id in unmatched ) {
            if ( unmatched.hasOwnProperty( id ) ) {
                var optionGroup = this.findWhere( {id: parseInt( id )} );
                optionGroup.optionList.toggleDisabledOptions( unmatched[id] );
            }
        }
    },

    optionsToHash: function () {
        var hash = {};
        this.each( function ( optionGroup ) {
            hash[optionGroup.get( 'id' )] = optionGroup.get( 'options' );
        } );

        return hash;
    },

    getUnmatchedOptionsHash: function ( availableSkuOptionsHash ) {
        var unmatched = {},
            options = this.optionsToHash();
        // iterates all opt dict perform diff against avail options
        for ( var id in options ) {
            if ( options.hasOwnProperty( id ) ) {
                unmatched[id] = _.difference( options[id], availableSkuOptionsHash[id] );
            }
        }

        return unmatched;
    },

    // cycle over option groups and verify each optionList has a current selection
    validate: function ( opt ) {
        opt = opt || {};

        var key,
            selected = this.getSelected();

        for ( key in selected ) {
            if ( selected.hasOwnProperty( key ) ) {
                if ( !selected[key] ) {
                    console.log( '@OptionGroupList validation failed: option missing' );
                    var optionGroup = this.findWhere( {id: parseInt( key )} ),
                        message = upi.i18n.getTextFromKey( 'lbl-selectOptionFor' ) + ' ' + optionGroup.get( 'name' ),
                        err = {
                            type: 'option missing',
                            groupId: optionGroup.get( 'id' ),
                            message
                        };

                    // trigger validation errors
                    switch ( opt.onError ) {
                        case 'showerror':
                            optionGroup.trigger( 'error', err );
                            break;
                        case 'showhint':
                            app.mediator.trigger( 'tooltip:addsku', err );
                            break;
                        default:
                        // fail silent
                    }

                    return false;
                }
            }
        }

        return true;
    }

} );

export default OptionGroupList;
